{
  "titles": {
    "bookTransfer": "Betaling verwerken"
  },
  "fields": {
    "labels": {
      "amount": "Bedrag",
      "counterpartName": "Naam rekeninghouder",
      "counterpartIban": "IBAN rekeninghouder",
      "reference": "Referentie",
      "description": "Omschrijving",
      "depositDate": "Datum storting"
    },
    "hints": {
    },
    "validationErrors": {
      "depositDate": {
        "maxDate": "{0} mag niet in de toekomst liggen"
      },
      "amount": {
        "max": "{0} mag niet groter zijn dan {1} voor deze stortingsdatum"
      }
    }
  },
  "errors": {
    "validation": {
    }
  },
  "messages": {
    "renewalRequestConfirmation": "De betaling van de financieringskosten en administratiekosten zijn voldaan. De incasso’s worden geannuleerd. De lening wordt ingelost met een nieuwe lening. De nieuwe lening start automatisch één dag nadat de looptijd van de huidige lening ten einde is gekomen. De huidige lening wordt afgesloten nadat de looptijd voorbij is.",
    "emptyStateDescription": "De incasso's worden aangemaakt. Zodra dit succesvol is, zullen ze hier worden getoond."
  },
  "actions": {
    "addTransfer": "Betaling toevoegen",
    "revalidateDirectDebits": "Betaling opnieuw controleren"
  },
  "type": {
    "DirectDebit": "Incasso",
    "Transfer": "Overboeking",
    "Renewal": "Afgelost met"
  },
  "status": {
    "Scheduled": "Ingepland",
    "Successful": "Betaald",
    "Failed": "Mislukt",
    "Cancelled": "Geannuleerd",
    "Processing": "Betaling in behandeling"
  },
  "specification": {
    "openAmount": "Openstaand bedrag",
    "administrationCosts": "Administratiekosten",
    "penaltyAmount": "Achterstallige rente",
    "renewedInterestAmountIncrease": "Verschil tarief"
  }
}
